import { motion } from "framer-motion";
import { MaskLines, Reveal } from "../site/Motion";
import { EASE } from "../../lib/api";

const STEPS = [
  ["Brief", "Tell us the site, the work and the headcount or volume. We ask the right questions up front."],
  ["Survey & proposal", "We visit or review the requirement, then share a clear scope, staffing plan and pricing."],
  ["Deploy", "Staff are selected, trained for your site and placed with a supervisor and a start-date plan."],
  ["Run & report", "Attendance, compliance and output are tracked and shared, with one contact for every issue."],
];

export const Process = () => (
  <section id="process" className="relative bg-[var(--bone)] py-24 text-[var(--ink)] md:py-36" data-testid="process-section">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 md:px-10 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <p className="overline flex items-center gap-3 text-[#8a5a00]"><span className="h-px w-8 bg-current" />How it works</p>
          <MaskLines lines={["From brief", "to boots", "on the floor."]}
            className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] md:text-7xl" />
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-sm text-base text-[#3d3a33] md:text-lg">
              A simple four-step engagement. No layers, no hand-offs between agencies — the same team that scopes your work runs it.
            </p>
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-6 lg:col-start-7">
        {STEPS.map(([t, d], i) => (
          <motion.li key={t} initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: EASE }}
            className="group grid grid-cols-[auto_1fr] gap-6 border-t border-[rgba(14,15,12,0.18)] py-10 md:gap-10" data-testid={`process-step-${i + 1}`}>
            <span className="font-display text-6xl font-black leading-none text-transparent [-webkit-text-stroke:1.5px_var(--ink)] transition-colors duration-500 group-hover:text-[var(--ink)] md:text-8xl">
              0{i + 1}
            </span>
            <div>
              <h3 className="font-display text-3xl font-extrabold uppercase md:text-4xl">{t}</h3>
              <p className="mt-3 max-w-md text-[#3d3a33]">{d}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
